import controller from './autocomplete.controller'
import template from './autocomplete.html'

const FrAutocompleteComponent = {
	bindings: {
		listValue: "<",
		minLength: "<",
		idField: "<",
		displayField: "<",
		templateItem: "<",
		placeholder: "<",
		activateOnFocus: "<",
		autoHideDropdown: "<",
		searchText: '<',
		searchFileds: '<',
		maxItemsToRender: '@',
		dropdownParent: '@',
		sortField: "@",
		grouped: "@",
		onChangeSelection: "&",
		onBlur: "&",
		onFocus: "&",
		onClearSelection: "&"
	},
	controller,
	template,
};

export default FrAutocompleteComponent;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/autocomplete/autocomplete.component.js